export const academicYearOf = (iso) => {
  const d = new Date(iso);
  const y = d.getFullYear();
  return d.getMonth() >= 8 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
};
